import * as Stimulus from "@hotwired/stimulus"

export class ClipboardController extends Stimulus.Controller {
    static values = {
        copyText: String
    }

    copy() {
        var originalText = this.element.innerText
        this.element.disabled = true;
        navigator.clipboard.writeText(this.copyTextValue)
            .then(() => {
                this.element.innerText = "Copied";
                setTimeout(() => {
                    this.element.innerText = originalText;
                    this.element.disabled = false;
                }, 1400);
            })
            .catch(err => {
                console.error('clipboard#copy', err)
            })
    }
}
